
    <div class="title-container">
      &nbsp;
      <p class="title">{{title}}</p>
      <button mat-icon-button mat-dialog-close class="close-btn" aria-label="Example icon button with a home icon">
        <mat-icon class="close-icon">close</mat-icon>
      </button>
    </div>
    <ng-content></ng-content>
  